// src/components/auth/ForgotPassword.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { sendResetLink } from "../../redux/slices/resets";

const schema = yup.object().shape({
  email: yup
    .string()
    .email("Please enter a valid email address")
    .required("Email is required"),
});

const ForgotPassword = () => {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const loading = useSelector((state) => state?.resets.loading);

  const onSubmit = async (data) => {
    try {
      await dispatch(sendResetLink({ email: data?.email }));
    } catch (err) {
      console.error("Error during password reset:", err);
    }
  };

  return (
    <>
      <section
        className="account-section overflow-hidden bg_img"
        style={{
          background: `url(${process.env.PUBLIC_URL}/images/account/login-signup.jpg)`,
        }}
      >
        <div className="container">
          <div className="account__main__wrapper float-start">
            <div className="account__form__wrapper">
              <div className="content text-center text-white">
                <h3 className="title text--base mb-4">Reset Your Password</h3>
                <p className="mb-4">
                  Please enter your email address to receive a link for
                  resetting your password.
                </p>
              </div>

              <form
                className="account__form form row g-4"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="col-12">
                  <div className="form-group">
                    <div className="input-pre-icon">
                      <i className="las la-user"></i>
                    </div>
                    <input
                      {...register("email")}
                      id="email"
                      type="email"
                      disabled={loading}
                      className={`form--control form-control style--two ${
                        errors.email ? "is-invalid" : ""
                      }`}
                      placeholder="Email Address"
                    />
                    {errors.email && (
                      <div className="invalid-feedback">
                        {errors.email.message}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <button
                      className="cmn--btn active w-100 btn--round"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? (
                        <div
                          className="spinner-border text-light"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      ) : (
                        "Send Reset Link"
                      )}
                    </button>
                  </div>
                </div>
              </form>

              <p className="account-switch mt-4 ">
                Remember your password?{" "}
                <Link className="text--base ms-2" to="/login">
                  Sign In
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ForgotPassword;
